import { Tooltip, type TooltipProps } from '@mui/material';
import { InfoIcon } from '@phosphor-icons/react';
import { type ReactNode } from 'react';

export interface HelpTooltipProps {
  tooltipContent: ReactNode;
  tooltipProps?: Pick<TooltipProps, 'placement'>;
}

export function HelpTooltip(props: HelpTooltipProps) {
  const { tooltipContent, tooltipProps } = props;

  return (
    <Tooltip
      title={tooltipContent}
      placement={tooltipProps?.placement || 'top'}
      {...tooltipProps}
      arrow
    >
      <InfoIcon />
    </Tooltip>
  );
}
